/**
 * Created by Administrador on 30/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('quantities', {
                parent: 'app',
                url: '/quantities',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/quantity/quantities.html',
                        controller: 'quantityCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['quantity']);
                            }],
                            quantities: ['quantityService', function (quantityService) {
                                return quantityService.getQuantityList();
                            }]
                        }
                    }
                }
            })
            .state('quantityNew', {
                parent: 'app',
                url: '/quantity/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/quantity/newQuantity.html',
                        controller: 'newEditQuantityCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminClassifications('quantities')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['quantity']);
                            }],
                            action: [function () {
                                return "new";
                            }],
                            quantity: [function () {
                                return null;
                            }],
                            quantities: ['quantityService', function (quantityService) {
                                return quantityService.getQuantityList();
                            }]
                        }
                    }
                }
            })
            .state('quantityEdit', {
                parent: 'app',
                url: '/quantity/:id/edit/:index',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/quantity/editQuantity.html',
                        controller: 'newEditQuantityCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminClassifications('quantities')
                            }],
                            quantity: ['quantityService', '$stateParams', function (quantityService, $stateParams) {
                                return quantityService.getQuantity($stateParams.id)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['quantity']);
                            }],
                            action: [function () {
                                return "edit";
                            }],
                            quantities: ['quantityService', function (quantityService) {
                                return quantityService.getQuantityList();
                            }]
                        }
                    }
                }
            })
            .state('quantityDelete', {
                parent: 'quantities',
                url: '/quantity/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configCargo/quantity/deleteQuantity.html',
                        controller: 'deleteQuantityCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            quantity: ['quantityService', function (quantityService) {
                                return quantityService.getQuantity($stateParams.id)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['quantity']);
                            }]
                        }
                    }).result.then(function () {
                        $state.go('quantities', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
